(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-footer"]) return;
  try {
    
    class CartNote extends HTMLElement {
      constructor() {
        super();
  
        this.addEventListener('change', debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
        }, 300))
      }
    }
  
    customElements.define('cart-note', CartNote);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);


  $(document).ready(function() {
    // Desktop dropdown hover functionality
    let navLinkwithDropdown = $('.wayfx-nav__link--has-dropdown'),
        navDropdown = $('.wayfx-nav__dropdown');

    navLinkwithDropdown.hover(
      function(){
        $(this).find(navDropdown).stop().slideDown(200);
        $(this).addClass('hovering');
      },
      function() {
        $(this).find(navDropdown).stop().hide();
        $(this).removeClass('hovering');
      }
    );

    // Mobile navigation
    let mobileNavTrigger = $("#mobileNavTrigger"),
        mobileNav = $('.wayfx-header__mobile-nav'),
        mobileNavMain = $('.wayfx-header__mobile-nav-main'),
        mobileNavSubmenus = $('.wayfx-header__mobile-nav-submenu'),
        mobileNavItemsWithChildren = $('.wayfx-header__mobile-nav-item.has-children'),
        mobileNavBackButtons = $('.wayfx-header__mobile-nav-back');

    // Toggle mobile nav open/close
    mobileNavTrigger.click(function() {
      $(this).toggleClass("is-active");
      mobileNav.toggleClass("is-active");

      // Reset to main panel when closing
      if (!mobileNav.hasClass('is-active')) {
        mobileNavMain.removeClass('submenu-active');
        mobileNavSubmenus.removeClass('is-active');
      }
    });

    // Open submenu when clicking parent with children
    mobileNavItemsWithChildren.click(function(e) {
      e.preventDefault();
      let submenuId = $(this).data('submenu-trigger');

      // Slide main panel left
      mobileNavMain.addClass('submenu-active');

      // Show the corresponding submenu
      $('[data-submenu="' + submenuId + '"]').addClass('is-active');
    });

    // Back button - return to main panel
    mobileNavBackButtons.click(function() {
      mobileNavMain.removeClass('submenu-active');
      mobileNavSubmenus.removeClass('is-active');
    });

    // Submenu title - also returns to main panel when clicked
    $('.wayfx-header__mobile-nav-submenu-title').click(function() {
      mobileNavMain.removeClass('submenu-active');
      mobileNavSubmenus.removeClass('is-active');
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 0px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
